import { useState } from 'react';
 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGamepad, faQuestion } from '@fortawesome/free-solid-svg-icons';

import Modal from 'react-bootstrap/Modal';

import { faClose } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'


import './commentjouernovo.css';
import './Carrosel.css';


const CommentJouerNovo = ()=> {
  const [aberto, setAberto] = useState(false);

  const handleClose = () => setAberto(false);
  const handleShow = () => setAberto(true);

  return (
    <>

    <div className="container-aide" id="aide-jeu" data-tooltip-content="Comment jouer">
    
         <button className='aide' >
                  <FontAwesomeIcon icon={faGamepad} className='aide-button' onClick={handleShow}></FontAwesomeIcon>
                </button>
                <Tooltip anchorSelect=".container-aide" place="left" />

      <div className='container-modal'>

      <Modal className='modal-aide'
        show={aberto}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
            
        <Modal.Body>
        <button className='fecha-modal'>
          <FontAwesomeIcon icon={faClose} className="fecha-aide" onClick={handleClose} />
        
          </button>
          <div className='comment-jouer'> <h3>Comment jouer?</h3></div>

            <div className='modal-guide'>
                <div className='guide-step1' id='guide-steps'>
                    <div className='notes-step1'>
                        <h6>- Cliquez sur la case Départ pour commencer.</h6>
                        <div className='step1'>
                          
                        </div>
                    </div>
                </div>
                <div className='guide-step2' id='guide-steps'>
                    <div className='notes-step2'>
                        <h6>-  Le dé apparaît en haut à droite. Cliquez sur le dé.</h6>
                        <div className='step2'>
                          <div className='icon-step2'>
                          <div className='step2-image'></div>
                          </div>
                        </div>
                    </div>
                </div>
                <div className='guide-step3' id='guide-steps'>
                    <div className='notes-step3'>
                        <h6>- Avancez du nombre de cases indiqué sur le dé.</h6>
                        <div className='step3'>
                        </div>
                    </div>
                </div>
             {/*    <div className='guide-step4' id='guide-steps'>
                    <div className='notes-step4'>
                        <h6>- Utilisez la flèche pour voir les cartes suivantes.
                        </h6>
                        <div className='step4'>
                        <div className='icon-step4'>
                          <div className='step4-image'></div>
                          </div>
                        </div>
                    </div>
                </div> */}
                <div className='guide-step5' id='guide-steps'>
                    <div className='notes-step5'>
                        <h6> - Passez le curseur de votre souris sur la carte pour voir le point d'interrogation et cliquez pour voir la question. Vous pouvez aussi simplement cliquer au centre de la carte.
                          <br></br>
                          - Cliquez sur le point d’interrogation de la carte visitée.
                        </h6>
                       <div className='step5'>
                       <button className='btn-icon'>
                <FontAwesomeIcon icon={faQuestion} className="icon-btn" />
              </button>
                        </div>
                    </div>
                </div>
                <div className='guide-step6' id='guide-steps'>
                    <div className='notes-step6'>
                        <h6>-  Répondez à la question en cliquant sur A ou B.</h6>
                       <div className='step6'>
                        </div>
                    </div>
                </div>
                    <div className='guide-step2' id='guide-steps'>
                    <div className='notes-step2'>
                        <h6>- Lisez la bonne réponse et cliquez à nouveau sur le dé pour continuer de jouer.</h6>
                        <div className='step2'>
                          <div className='icon-step2'>
                          <div className='step2-image'></div>
                          </div>
                        </div>
                    </div> 
                </div>
               <div className='guide-step4' id='guide-steps'>
                    <div className='notes-step4'>
                        <h6>
                          - Cliquez sur la flèche pour voir les cases suivantes.
                        </h6>
                        <div className='step4'>
                        <div className='icon-step4'>
                          <div className='step4-image'></div>
                          </div>
                        </div>
                    </div>
                </div>
                 <div className='guide-step7' id='guide-steps'>
                    <div className='notes-step7'>
                        <h6>- Après 10 réponses, votre score s’affiche.</h6>
                       <div className='step7'>
                        </div>
                    </div>
                </div>

            </div>
      
        </Modal.Body>
        <Modal.Footer>
         
          <button className='fecha-modal'>
          <FontAwesomeIcon icon={faClose} className="fecha-aide" onClick={handleClose} />
        
          </button>
        </Modal.Footer>
      </Modal>
      </div>
      </div>
    </>

  );
}

export default CommentJouerNovo;